import { productsSaga } from './products.sagas';
import { reducer } from './products.reducer';
import { ProductsActions } from './products.action';

export {
    productsSaga,
    reducer,
    ProductsActions
}